var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('v-breadcrumbs',{staticClass:"capitalize",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"disabled":item.disabled}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])]}}],null,false,1008008951)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }